export default __webpack_public_path__ + "static/media/icon_menuarrow_disabled.55604442.png";